import React, { useReducer, useEffect, useLayoutEffect } from "react";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { submitUserCustomSettings, updateUserCustomSettings } from "api";
import Cookies from "js-cookie";
import tourReducer from "../tourReducer";
import tourInitialState from "../tourInitialState";
import TourTooltip from "../TourTooltip";
import getDashboardTourSteps from "./dashboardTourSteps";

function DashboardTour({ isLayoutLocked, setIsLayoutLocked }) {
  const intl = useIntl();
  const TOUR_STEPS = getDashboardTourSteps(intl);

  const [tourState, dispatch] = useReducer(tourReducer, tourInitialState);

  // Starts tour if runDashboardTour is true
  useLayoutEffect(() => {
    const customSettings = JSON.parse(localStorage.getItem("customSettings") || null);
    const prevState = customSettings && customSettings.tourState;
    if ((prevState && prevState.runDashboardTour === false) || Cookies.get("cargobase_logged_in_as_token")) {
      dispatch({ type: "STOP" });
      return;
    }
    dispatch({ type: "START" });
  }, []);

  // Updates tourState in localStorage and API when tour is stopped
  useEffect(() => {
    const customSettings = JSON.parse(localStorage.getItem("customSettings")) || {};
    if (!tourState.run && !Cookies.get("cargobase_logged_in_as_token")) {
      // update custom settings via API
      const func = customSettings ? updateUserCustomSettings : submitUserCustomSettings;
      func({ tourState: { ...customSettings.tourState, runDashboardTour: tourState.run } }).then((res) =>
        localStorage.setItem("customSettings", JSON.stringify(res.data)),
      );
    }
  }, [tourState]);

  useEffect(() => {
    if (tourState.stepIndex === 4 && !isLayoutLocked) dispatch({ type: "NEXT_OR_PREV", payload: { stepIndex: 6 } });
  }, [isLayoutLocked]);

  const handleJoyrideCallback = (data) => {
    const { action, index, type, status } = data;
    if (action === ACTIONS.CLOSE || (status === STATUS.SKIPPED && tourState.run) || status === STATUS.FINISHED) {
      dispatch({ type: "STOP" });
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      // if user clicks back whilst on step 5, lock the layout
      if (index === 5 && action === ACTIONS.PREV && !isLayoutLocked) setIsLayoutLocked(true);
      dispatch({
        type: "NEXT_OR_PREV",
        payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
      });
    }
  };

  return <JoyRide {...tourState} callback={handleJoyrideCallback} steps={TOUR_STEPS} tooltipComponent={TourTooltip} />;
}

export default DashboardTour;

DashboardTour.propTypes = {
  isLayoutLocked: PropTypes.bool.isRequired,
  setIsLayoutLocked: PropTypes.func.isRequired,
};
